import { render } from "./SobreEmpresa.vue?vue&type=template&id=e2f9c4d8&scoped=true&ts=true"
import script from "./SobreEmpresa.vue?vue&type=script&lang=ts"
export * from "./SobreEmpresa.vue?vue&type=script&lang=ts"

import "./SobreEmpresa.vue?vue&type=style&index=0&id=e2f9c4d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f9c4d8"]])

export default __exports__